import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProgramCard from "./program-card";
import axios from "axios";
import LoadingContent from "../loading-content-1";
import InfiniteScroll from 'react-infinite-scroll-component';

var Api_url = process.env.GATSBY_API_URL;
console.log("API_URL=" + Api_url);

const axiosConfig = {
  headers: {
    "Content-Type": "application/json; text/html; charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
};
class NationalProgramPage extends React.Component {
  constructor() {
    super();
    this.state = {
      LoadingFlag: false,
      TotalRecords: 0,
      PageNo: 1,
      Records: [],
      hasMore: true,
    };
  }
  getAllRecords = async () => {
    console.log("getAllRecords called ");

    var PageNo = this.state.PageNo;
    console.log("PageNo=" + PageNo);

    var url = Api_url + `/api/programs/events/lists?page=` + PageNo;
    console.log("url=" + url);
    var postData = {
      UserInterface: 1
    };
    this.setState({ LoadingFlag: true });
    console.log({ postData });
    await axios
      .post(url, postData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        console.log("res=" + JSON.stringify(res));

        this.setState({ LoadingFlag: false });

        var flag = res.data.flag;
        var records = res.data.records;
        var TotalPage = records.TotalPage;
        console.log({ records });

        if (flag) {
          console.log("TotalPage=" + TotalPage + "; PageNo=" + this.state.PageNo + "; hasMore=" + this.state.hasMore);
          if (TotalPage > this.state.PageNo) {
            this.setState({ PageNo: this.state.PageNo + 1 });
          } else {
            this.setState({ hasMore: false });
          }

          var receive_data = records.EventsData;
          var current_data = this.state.Records;
          var result = current_data.concat(receive_data);
          var n1 = result.length;
          console.log("n1=" + n1);

          this.setState({ Records: result, TotalRecords: n1 });
        } else {
          this.setState({ hasMore: false });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  componentDidMount() {
    console.log("componentDidMount called ");
    this.getAllRecords();
  }
  render() {
    return (
      <section className="event-page pt-120 pb-120">
        <Container>
          <div className="container">
            <InfiniteScroll
              dataLength={this.state.Records.length}
              next={this.getAllRecords}
              hasMore={this.state.hasMore}
              loader={''}
              scrollThreshold={0.7}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>That's all for now. Come back later for more.</b>
                </p>
              }
            >
              <div className="gallery-3-col">
                {this.state.Records.length > 0 ? this.state.Records.map((event, index) => (
                  <ProgramCard data={event} key={`event-card-key-${index}`} toBaseUrl="/programs/national-program-details"/>
                )) : ''}
              </div>
              {this.state.LoadingFlag ? <LoadingContent /> : ''}
            </InfiniteScroll>
          </div>
        </Container>
      </section>
    );
  }
}

export default NationalProgramPage;
